<template>
    <div class="isPc">
        <img src="../../static/img/yidong.png" alt="">

    </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.isPc{
    img{
        display: block;
        width: 100%;
        // height: 100%;
        //  margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Developing.vue